import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getBrandsByCatalogHierarchy } from '../../../../APIClient/shop';

const NewCircleModalData = props => {
  const { selectedIndustries, selectedDepartments, setBrandsToConsider } = props;

  // State
  const [isOnBrandsTabFromCategories, setIsOnBrandsTabFromCategories] = React.useState(false);

  // Refs
  const previousTabVariable = React.useRef(null);
  const lastFetchedHash = React.useRef(null);
  const isFetching = React.useRef(false);

  // Derived state
  const selectedHash = [...selectedIndustries, ...selectedDepartments].map(item => `${item.id}-${item.Industry_id || ''}`).join('-');

  // Data fetching logic
  const fetchData = async hash => {
    if (!hash || isFetching.current) return;

    isFetching.current = true;
    props.setIsLoadingBrands(true);

    const params = {};
    if (selectedIndustries.length) params.Industry_ids = selectedIndustries.map(industry => industry.id).join(',');
    if (selectedDepartments.length) params.Department_ids = selectedDepartments.map(department => department.id).join(',');

    try {
      const resp = await getBrandsByCatalogHierarchy(params);
      setBrandsToConsider(resp.brands);
      lastFetchedHash.current = hash;
    } catch (error) {
      console.error('Error fetching brands by catalog hierarchy:', error);
    } finally {
      isFetching.current = false;
      props.setIsLoadingBrands(false);
    }
  };

  // Debounced fetch for normal changes
  const debouncedFetch = React.useCallback(_.debounce(fetchData, 1_000), []);

  // Track tab transitions
  React.useEffect(() => {
    const isTransitioningToBrands = previousTabVariable.current === 'categories' && props.activePanel.variable === 'brands';

    setIsOnBrandsTabFromCategories(isTransitioningToBrands);
    previousTabVariable.current = props.activePanel.variable;
  }, [props.activePanel.variable]);

  // Handle normal changes to selectedHash with debounce
  React.useEffect(() => {
    if (selectedHash.length && !isOnBrandsTabFromCategories && lastFetchedHash.current !== selectedHash) {
      debouncedFetch(selectedHash);
    }
  }, [selectedHash, debouncedFetch, isOnBrandsTabFromCategories]);

  // Handle immediate fetch on brands tab transition
  React.useEffect(() => {
    const shouldFetchImmediately = isOnBrandsTabFromCategories && selectedHash.length && lastFetchedHash.current !== selectedHash;

    if (shouldFetchImmediately) {
      debouncedFetch.cancel();
      fetchData(selectedHash);
    }
  }, [isOnBrandsTabFromCategories, selectedHash]);

  return null;
};

NewCircleModalData.propTypes = {
  activePanel: PropTypes.object.isRequired,
  selectedIndustries: PropTypes.array.isRequired,
  selectedDepartments: PropTypes.array.isRequired,
  setBrandsToConsider: PropTypes.func.isRequired,
  setIsLoadingBrands: PropTypes.func.isRequired
};

export default NewCircleModalData;
